import { DatePipe } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudAmpliacionAprobacionModel, SolicitudesAmpliacionAprobacionModel } from 'src/app/models/calendario-sso/ISolicitudAmpliacionAprobacionModel';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterSolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/IFilterSolicitudAmpliacionSsoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudAmpliacionSsoService {
  private configUrl = [environment.apiGatewayUrl, 'solicitudes-ampliacion'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

    getList(
      model: IFilterSolicitudAmpliacionSsoModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<SearchResultModel<SolicitudAmpliacionSsoModel[]>> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`page=${model.page}`);
      queryParams.push(`take=${model.pageSize}`);
      
      if (model.meses.length > 0) {
        queryParams.push(`meses=${model.meses.join(',')}`);
      }
      if (model.anio >0) {
        queryParams.push(`anio=${model.anio}`);
      }

      if (model.sedes.length > 0) {
        queryParams.push(`sedes=${model.sedes.join(',')}`);
      }
  
      if (model.contratista !== '') {
        queryParams.push(`contratista=${model.contratista}`);
      }
  
      if(model.tipos.length > 0){
        queryParams.push(`tipos=${model.tipos.join(',')}`);
      }
  
      if(model.idEstado > 0){
        queryParams.push(`idEstado=${model.idEstado}`);
      }
  
      if (model.solicitante !== '') {
        queryParams.push(`solicitante=${model.solicitante}`);
      }

      if (model.idCompania > 0) {
        queryParams.push(`companias=${model.idCompania}`);
      }
  
      return this.http.get<SearchResultModel<SolicitudAmpliacionSsoModel[]>>(
        this.configUrl + '?'+ queryParams.join('&')
      );
    }
  
    exportList(
      model: IFilterSolicitudAmpliacionSsoModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<HttpResponse<Blob>> {
      let queryParams: string[] = new Array<string>();
      
      if (model.meses.length > 0) {
        queryParams.push(`meses=${model.meses.join(',')}`);
      }
      if (model.anio >0) {
        queryParams.push(`anio=${model.anio}`);
      }

      if (model.sedes.length > 0) {
        queryParams.push(`sedes=${model.sedes.join(',')}`);
      }
  
      if (model.contratista !== '') {
        queryParams.push(`contratista=${model.contratista}`);
      }
  
      if(model.tipos.length > 0){
        queryParams.push(`tipos=${model.tipos.join(',')}`);
      }
  
      if(model.idEstado > 0){
        queryParams.push(`idEstado=${model.idEstado}`);
      }
  
      if (model.solicitante !== '') {
        queryParams.push(`solicitante=${model.solicitante}`);
      }

      if (model.idCompania > 0) {
        queryParams.push(`companias=${model.idCompania}`);
      }
  
      return this.http.get(`${this.configUrl}/exportar?${queryParams.join('&')}`, { observe: 'response', responseType: 'blob'});
    }

    getListPendientes(
      model: IFilterSolicitudAmpliacionSsoModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<SearchResultModel<SolicitudAmpliacionSsoModel[]>> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`page=${model.page}`);
      queryParams.push(`take=${model.pageSize}`);
      
      if (model.sedes.length > 0) {
        queryParams.push(`sedes=${model.sedes.join(',')}`);
      }
  
      if (model.contratista !== '') {
        queryParams.push(`contratista=${model.contratista}`);
      }
  
      if(model.tipos.length > 0){
        queryParams.push(`tipos=${model.tipos.join(',')}`);
      }
  
      if (model.solicitante !== '') {
        queryParams.push(`solicitante=${model.solicitante}`);
      }

      if (model.idCompania > 0) {
        queryParams.push(`companias=${model.idCompania}`);
      }
  
      return this.http.get<SearchResultModel<SolicitudAmpliacionSsoModel[]>>(
        this.configUrl + '/pendientes?'+ queryParams.join('&')
      );
    }
  
    exportPendientesList(
      model: IFilterSolicitudAmpliacionSsoModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<HttpResponse<Blob>> {
      let queryParams: string[] = new Array<string>();
      
      if (model.sedes.length > 0) {
        queryParams.push(`sedes=${model.sedes.join(',')}`);
      }
  
      if (model.contratista !== '') {
        queryParams.push(`contratista=${model.contratista}`);
      }
  
      if(model.tipos.length > 0){
        queryParams.push(`tipos=${model.tipos.join(',')}`);
      }
  
      if (model.solicitante !== '') {
        queryParams.push(`solicitante=${model.solicitante}`);
      }

      if (model.idCompania > 0) {
        queryParams.push(`companias=${model.idCompania}`);
      }
  
      return this.http.get(`${this.configUrl}/exportar-pendientes?${queryParams.join('&')}`, { observe: 'response', responseType: 'blob'});
    }

    submit(model: SolicitudAmpliacionSsoModel) {
      return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
    }

    registrarAprobacion(model: SolicitudesAmpliacionAprobacionModel){
      return this.http.post<ActionResultModel>(`${this.configUrl}/registrar-aprobacion`, model);
    }
}
